
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extensions/pagerduty",
      function () {
        return require("private-next-pages/extensions/pagerduty.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extensions/pagerduty"])
      });
    }
  